import "./index.scss";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dialog,Typography,Stack,Box,DialogTitle,IconButton} from "@mui/material";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import {currency} from "../../constants/common";
import {SERVER_URL} from "../../constants/api";
import ApiService from "../../services/api-service";

export default function OffboardingBox(props) {
  const { t } = useTranslation("common");
  const [loading, setLoading] = React.useState(false);
  const [cryptoCharges, setCrytpoCharges] = React.useState();
  const [amount, setAmount] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [memo, setMemo] = React.useState("");
  const [boxTitle, setBoxTitle] = React.useState("");
  const [amountLabel, setAmountLabel] = React.useState("");
  const [memoLabel, setMemoLabel] = React.useState("");
  const [minAmount, setMinAmount] = React.useState(0);
  const [maxAmount, setMaxAmount] = React.useState(0);
  const [minMsg, setMinMsg] = React.useState("");
  const [minMsgShort, setMinMsgShort] = React.useState("");
  const [addressLabel, setAddressLabel] = React.useState("");
  const [maxMsg, setMaxMsg] = React.useState("");
  const [txProceed, setTxProceed] = React.useState("");

  const getCryptoCharges = async () => {
    try {
      setLoading(true);
      const response = await ApiService.CHARGES();
      setCrytpoCharges(response["result"]);
      cryptoCharges && updateMinMax();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const updateMinMax = () => {
    let isProd = ( SERVER_URL === "https://core.siki.io" );
    let minVal = 0;
    let maxVal = 0;

    let oneDollarInHbar = Number((1 / cryptoCharges.hbarValueInUsd).toFixed(2));
    let oneDollarInMatic = Number((1 / cryptoCharges.maticValueInUsd).toFixed(2));
    let oneDollarInNear = Number((1 / cryptoCharges.nearValueInUsd).toFixed(2));

    oneDollarInHbar = Math.ceil( oneDollarInHbar*100 + 1 ) / 100;
    oneDollarInMatic = Math.ceil( oneDollarInMatic*100 + 1 ) / 100;
    oneDollarInNear = Math.ceil( oneDollarInNear*100 + 1 ) / 100;

    switch(props.transferType) {
      case currency.MATIC:
        minVal = isProd ? oneDollarInMatic : 0.1;
        maxVal = 250;
        break;
      case currency.HBAR:
        minVal = isProd ? oneDollarInHbar : 4;
        maxVal = 10000;
        break;
      case currency.NEAR:
        minVal = isProd ? oneDollarInNear : 0.2;
        maxVal = 250;
        break;
      case currency.SIKI:
        minVal = isProd ? cryptoCharges.minimumCashout : 5;
        maxVal = 2000;
        break;
    }

    setMinMsg( t(props.transferType + "OffboardingBox.minAmount", { tokenAmount: minVal } ));
    setMinMsgShort( t(props.transferType + "OffboardingBox.minAmountShort", { tokenAmount: minVal }));
    setMaxMsg( t(props.transferType + "OffboardingBox.maxAmount", { tokenAmount: maxVal }));
    setMinAmount( minVal );
    setMaxAmount( maxVal );
  }

  useEffect(() => {
    getCryptoCharges();
    setAmount("");
    setAddress("");
    setMemo("");
    setTxProceed( t("proceed") );

    setBoxTitle( t(props.transferType + "OffboardingBox.title"));
    setAmountLabel( t(props.transferType + "OffboardingBox.amountLabel"))
    setAddressLabel( t( props.transferType === currency.SIKI ? "paypalAddressLabel" : "walletAddressLabel" ) );
    setMemoLabel( t("memoLabel"))

  }, [props.open,props.transferType]);

  return (
    <div>
      <Dialog
        open={props.open}
        keepMounted
        onClose={() => {
          props.handleClose();
          setAmount("");
          setAddress("");
        }}
        PaperProps={{
          style: {
            position: "relative",
            backgroundColor: "#090909",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            paddingBottom: "16px",
            backgroundImage: "none",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <DialogTitle
            color="default"
            sx={{
              padding: "16px",
              color: "#ffffff",
              fontSize: "20px",
              borderBottom: "1px solid #1E1E1E",
            }}
          >
            {boxTitle}
            <IconButton
              aria-label="close"
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
              onClick={() => {
                props.handleClose(false);
                setAmount("");
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <Stack sx={{ padding: "16px", borderBottom: "1px solid #1E1E1E" }}>
            <Typography className="fs-14" mb="5px !important">
              {amountLabel}
            </Typography>
            <DialogContent sx={{ padding: 0 }}>
              <Box
                style={{
                  borderRadius: "25px",
                  border: "1px solid gray",
                  padding: "16.5px 14px",
                  backgroundColor: "#1E1E1E",
                }}
              >
                <Stack direction={"row"}>
                  <input
                    value={amount}
                    type="number"
                    onChange={(e) => setAmount(e.target.value)}
                    onKeyDown={(e) =>
                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                    }
                    style={{
                      border: "none",
                      minWidth: "200px",
                      width: "90%",
                      backgroundColor: "transparent",
                      color: "#ffffff",
                    }}
                    placeholder={ minMsgShort }
                    autoFocus
                  />
                </Stack>
              </Box>
            </DialogContent>
            { amount && amount < minAmount ? (
              <Typography
                variant="body2"
                sx={{ fontSize: "12px" }}
                mt={1}
                color="error"
              >
                { minMsg }
              </Typography>
            ) : amount && amount > maxAmount ? (
              <Typography
                variant="body2"
                sx={{ fontSize: "12px" }}
                mt={1}
                color="error"
              >
                { maxMsg }
              </Typography>
            ) : null}
          </Stack>

          <Stack sx={{ padding: "16px", borderBottom: "1px solid #1E1E1E" }}>
            <Typography className="fs-14" mb="5px !important">
              {addressLabel}
            </Typography>
            <DialogContent sx={{ padding: 0 }}>
              <Box
                style={{
                  borderRadius: "25px",
                  border: "1px solid gray",
                  padding: "16.5px 14px",
                  backgroundColor: "#1E1E1E",
                }}
              >
                <Stack direction={"row"}>
                  <input
                    value={address}
                    type="string"
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder={ "" }
                    style={{
                      border: "none",
                      minWidth: "200px",
                      width: "90%",
                      backgroundColor: "transparent",
                      color: "#ffffff",
                    }}
                  />
                </Stack>
              </Box>
            </DialogContent>
          </Stack>

          { props.transferType !== currency.SIKI &&
          <Stack sx={{ padding: "16px", borderBottom: "1px solid #1E1E1E" }}>
            <Typography className="fs-14" mb="5px !important">
              {memoLabel}
            </Typography>
            <DialogContent sx={{ padding: 0 }}>
              <Box
                style={{
                  borderRadius: "25px",
                  border: "1px solid gray",
                  padding: "16.5px 14px",
                  backgroundColor: "#1E1E1E",
                }}
              >
                <Stack direction={"row"}>
                  <input
                    value={memo}
                    type="string"
                    onChange={(e) => setMemo(e.target.value)}
                    placeholder={ "" }
                    style={{
                      border: "none",
                      minWidth: "200px",
                      width: "90%",
                      backgroundColor: "transparent",
                      color: "#ffffff",
                    }}
                  />
                </Stack>
              </Box>
            </DialogContent>
          </Stack>
          }

          <Stack
            justifyContent="center"
            sx={{
              width: "50%",
              margin: "auto !important",
              marginTop: "8px !important",
            }}
          >
              <Button
                onClick={() => {
                  if ((amount !== "" ) ) {
                    props.handleSubmit(amount,address,memo);
                  }
                }}
                title={ txProceed }
                sx={{
                  height: "30px !important",
                  fontWeight: "bold",
                }}
                variant="contained"
                color="primary"
              >
                { txProceed }
              </Button>
          </Stack>
        </Stack>
      </Dialog>
    </div>
  );
}
